import * as daHelper from '../../Dialogs/dialogActionsHelper';
import {dialogsNames} from '../../../enums/dialogsNames';
import {api as exportApi} from '../../Export/exportActions';
import * as qplService from '../../../services/Qpls/qplsService';
import {ImportTypes} from '../../../enums/importTypes';


const config = {
  getSubmitMethod: (submitConfigData) => {
    return ImportTypes.IMPORT_QPL_JSON === submitConfigData?.importType ?
      qplService.importQplJson : qplService.importQplForMaterialTypeJson;
  }
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.IMPORT_FILES_JSON_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.IMPORT_FILES_JSON_DIALOG),

};

export let api = {
  ...daHelper.getApiActions(actions, config),

}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

  exportDomSchema(importType) {
    return function (dispatch, getState) {
      ImportTypes.IMPORT_QPL_JSON === importType ?
      exportApi.exportQplDomSchema(dispatch, getState)() :
      exportApi.exportMaterialQplRulesDomSchema(dispatch, getState)() ;
    }
  }
};
